module.exports = {
	"description": "Certain factors can lead to or escalate violent, aggressive or responsive behaviours. These factors tend to fall into four categories: physical, psychological, environmental, and activity triggers. Documenting known triggers and behaviours and asking your patient, client or substitute decision maker (SDM) to help identify them can help you manage them more effectively and safely. Use the information collected and intervention resources listed to develop an individualized violence prevention care plan and a safety plan to protect workers at risk.",
	"label": "C",
	"subsections": [
		{
			"comments": null,
			"factors": {
				"physical": {
					"checked": false,
					"text": "Physical triggers — e.g., hunger, pain, infection, new medication",
					"title": "Physical Triggers"
				},
				"psychological": {
					"checked": false,
					"text": "Psychological – e.g., fear, uncertainty, feeling neglected, loss of control, being told to calm down, being lectured",
					"title": "Psychological Triggers"
				},
				"environmental": {
					"checked": false,
					"text": "Environmental triggers — e.g., noise, lighting, temperature, scents, privacy, time of day, days of the week, small spaces / overcrowding, visitors",
					"title": "Environmental Triggers"
				},
				"activity": {
					"checked": false,
					"text": "Activity triggers — e.g., bathing, medication, past experiences, toileting, changes in routine, resistance to care",
					"title": "Activity Triggers"
				}
			},
			"title": "Considerations"
		},
		{
			"comments": null,
			"factors": {
				"walk": {
					"checked": false,
					"text": "Go for a Walk"
				},
				"music": {
					"checked": false,
					"text": "Listen to music"
				},
				"tv": {
					"checked": false,
					"text": "Watch TV"
				},
				"draw": {
					"checked": false,
					"text": "Draw"
				},
				"read": {
					"checked": false,
					"text": "Read"
				},
				"alone": {
					"checked": false,
					"text": "Have space and time alone"
				},
				"talk": {
					"checked": false,
					"text": "Talk 1:1 with _____________ (please indicate)"
				},
				"activity": {
					"checked": false,
					"text": "Participate in activities"
				},
				"book": {
					"checked": false,
					"text": "Read Bible, or book"
				},
				"consult": {
					"checked": false,
					"text": "Consult a family member or friend"
				}
			},
			"title": "Preventative Measures"
		},
		{
			"comments": null,
			"title": "De-escalation Techniques",
			"factors": {
				"space": {
					"checked": false,
					"text": "Respect personal space"
				},
				"listen": {
					"checked": false,
					"text": "Actively Listen"
				},
				"choices": {
					"checked": false,
					"text": "Offer choices"
				},
				"contact": {
					"checked": false,
					"text": "Give eye contact"
				},
				"humor": {
					"checked": false,
					"text": "Use humor"
				}
			}
		}
	],
	"title": "Contributing Factors"
};


//////////////////
// WEBPACK FOOTER
// ./src/initialStore/contributingFactors.json
// module id = 883
// module chunks = 0